import services  from '@/http'
import { returnResolve, returnReject } from '../helpers/response'

export function service(params) {

    return new Promise( async (resolve, reject) => {

        try {

            let payload = params.payload ? params.payload : {};

            let routParams = params.params;
            if (!routParams) {
                const extractedParams = {};
                if (payload.id != null) extractedParams.id = payload.id;
                if (payload.teacherId != null) extractedParams.teacherId = payload.teacherId;
                if (payload.institutionId != null) extractedParams.institutionId = payload.institutionId;
                if (payload.transferId != null) extractedParams.transferId = payload.transferId;
                if (payload.work_time_id != null) extractedParams.work_time_id = payload.work_time_id;
                if (payload.accessToken != null) extractedParams.accessToken = payload.accessToken;
                routParams = Object.keys(extractedParams).length > 0 ? extractedParams : null;
            }
            
            let data;

            if(routParams != undefined && payload.with != undefined) {
                routParams.with = payload.with
            }

            if(params.idAndPayload){
                data = await services[params.module][params.action](routParams, payload);
            }else{
                
                if(routParams){
                    data = await services[params.module][params.action](routParams, payload);
                }else{
                    data = await services[params.module][params.action].call({}, payload);
                }
            }

            if(params.unformatResponse){
                resolve(data);
            }else{
                resolve(returnResolve(data));
            }

        } catch(error) {

            if(params.unformatResponse){
                reject(error);
            }else{
                reject(returnReject(error));
            }

        }
    });

}

